import { useEffect, useRef, useState } from "react";
import { ContentContainer } from "../general/ContentContainer";
import Dropdown from "../ui/dropdown";
import Input from "../ui/input";
import {
  useGetBooks,
  useGetImam,
  useModifyNarrationInfo,
} from "../../api/hooks/allHooks";
import { useQueryClient } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import {
  clearNarration,
  createNarration,
} from "../../features/narrationSave/narrationSlice";
import { toast } from "react-toastify";
import Button from "../ui/buttons/primary-button";
import { useNavigate } from "react-router-dom";
import { customApiCall } from "../../utils/axios";
import { CircularProgress, Stack, useMediaQuery } from "@mui/material";
import { AiOutlineClose } from "react-icons/ai";
import apiUrls from "../../api/urls";
import { SingleNarration } from "../../pages/NarrationWarehouseLT";
import { InputWithSuggestionWithDebounceBlur } from "../general/InputWithSuggestion";
import { BiLoader } from "react-icons/bi";
import { getUserFromLocalStorage } from "../../utils/localStorage";
import { SingleNarrationSummariesForRead } from "./NarrationSummaryEditForm";

const emptyNarration = {
  imam: null,
  book: null,
  name: null,
  narrator: null,
  content: null,
  book_vol_no: null,
  book_page_no: null,
  book_narration_no: null,
  is_complete: null,
};

const SimilarNarrations = ({
  narrationContent,
  setIsOpen,
  isOpen,
  setHasSimilar,
  trigger,
  setTrigger,
  isLoading,
  setIsLoading,
}) => {
  const [similar, setSimilar] = useState([]);
  const url = apiUrls.narration.similar;
  useEffect(() => {
    const fn = async () => {
      setTrigger(false);
      setIsLoading(true);
      try {
        const data = { text: narrationContent };
        const resp = await customApiCall.post({ data, url });
        setSimilar(resp);
        setHasSimilar(!!resp.length);
        // if (resp?.length)
        //   setTrigger(true)
      } catch {
      } finally {
        setIsLoading(false);
      }
    };
    if (trigger) fn();
  }, [trigger, narrationContent]);

  if (similar.length && isOpen)
    return (
      <div
        className="w-full h-full fixed "
        style={{
          backgroundColor: "#0009",
          zIndex: 100,
        }}
      >
        <div
          className="w-2/3  fixed top-1/2 left-1/2 overflow-scroll"
          style={{
            borderRadius: "8px",
            backgroundColor: "white",
            transform: "translate(-50%, -50%)",
            zIndex: 100,
            border: "1px solid #ccc",
            height: "75%",
          }}
        >
          {isLoading && (
            <CircularProgress
              className="absolute top-1/2 left-1/2 -transform-x-1/2 -transform-y-1/2 "
              color="success"
            />
          )}
          <div
            style={{
              flexDirection: "column",
            }}
            className="relative p-6 flex gap-8  items-center "
          >
            {similar.length > 0 && (
              <>
                <p>{similar.length} حدیث مشابه یافت شد</p>
                {similar.map((narration) => {
                  return (
                    <SingleNarration narration={narration} className="w-full" />
                  );
                  // return <p>{item.content}</p>;
                })}
              </>
            )}
            <Button
              variant="primary"
              className="w-30"
              onClickHandler={() => {
                setTrigger(false);
                setIsOpen(false);
              }}
            >
              بستن
            </Button>
          </div>
          <AiOutlineClose
            className="absolute cursor-pointer right-2 top-2"
            onClick={() => {
              setTrigger(false);
              setIsOpen(false);
            }}
          />
        </div>
      </div>
    );
};

export function onBuffer(buffer) {
  const items = [];
  let boundary;
  while ((boundary = buffer.indexOf("},")) !== -1) {
    const candidate = buffer.slice(0, boundary + 1);
    buffer = buffer.slice(boundary + 2);

    try {
      const obj = JSON.parse(candidate);
      items.push(obj);
    } catch {}
  }
  return items;
}

export const AISuggestion = ({
  setIsOpen,
  visible,
  onConfirm,
  isSmallScreen,
  isTranslator = true,
}) => {
  const url = apiUrls.narration.translate;
  const urlLabeling = apiUrls.narration.labeling;
  const [text, setText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLabelingLoading, setIsLabelingLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [resultLabeling, setResultLabeling] = useState(null);
  const [percentage, setPercentage] = useState(null);
  const perRef = useRef(null);

  const user = getUserFromLocalStorage();

  const handleSubmit = async (e) => {
    setResult("");
    perRef.current = null;
    try {
      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.access || user.access_token}`,
        },
        body: JSON.stringify({ text }),
      });

      if (!res.ok) throw new Error(res.statusText);
      const reader = res.body.getReader();
      const decoder = new TextDecoder("utf-8");
      while (true) {
        const { done, value } = await reader.read();
        if (done) {
          setPercentage(100);
          break;
        }
        const chunk = decoder.decode(value, { stream: true });
        perRef.current += chunk?.length ?? 0;
        setResult((prev) => prev + chunk);

        const currPer = Math.round((40 * perRef.current) / text?.length, 2);
        setPercentage(Math.min(currPer, 100));
      }
    } catch (error) {
      console.error("Streaming error:", error);
      setResult((prev) => prev + "\nError: Failed to stream response.");
    }
  };

  const handleSubmitLabeling = async (e) => {
    setResultLabeling("");
    perRef.current = null;
    try {
      setPercentage(0);
      const res = await fetch(urlLabeling, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.access || user.access_token}`,
        },
        body: JSON.stringify({ text }),
      });

      if (!res.ok) throw new Error(res.statusText);
      const reader = res.body.getReader();
      const decoder = new TextDecoder("utf-8");
      while (true) {
        const { done, value } = await reader.read();
        if (done) {
          setPercentage(100);
          break;
        }
        const chunk = decoder.decode(value, { stream: true });
        perRef.current += chunk?.length ?? 0;
        setResultLabeling((prev) => prev + chunk);
      }
    } catch (error) {
      console.error("Streaming error:", error);
      setResultLabeling((prev) => prev + "\nError: Failed to stream response.");
    }
  };

  const onTranslateClick = async () => {
    setIsLoading(true);
    try {
      await handleSubmit();
    } catch {
    } finally {
      setIsLoading(false);
    }
  };

  const onLabelingClick = async () => {
    setIsLabelingLoading(true);
    try {
      await handleSubmitLabeling();
    } catch {
    } finally {
      setIsLabelingLoading(false);
    }
  };

  const onClick = (e) => {
    e.preventDefault();
    if (!text.trim()) return;

    if (isTranslator) onTranslateClick();
    else onLabelingClick();
  };

  const endRef = useRef();

  useEffect(() => {
    if (
      endRef.current &&
      ((percentage > 95 && percentage < 100) ||
        (resultLabeling && !isLabelingLoading))
    )
      endRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
  }, [result, resultLabeling, percentage, isLabelingLoading]);

  const isTranslationDone = isTranslator && result && !isLoading;
  const isLabelingDone = !isTranslator && resultLabeling && !isLabelingLoading;

  const closeAndClearTheModal = () => {
    setIsOpen(false);
    setResult(null);
    setResultLabeling(null);
  };
  return (
    <div
      className="fixed inset-0 "
      style={{
        backgroundColor: "#0009",
        zIndex: 10000,
        visibility: visible ? "visible" : "hidden",
      }}
    >
      {/* {percentage < 100 && percentage && (
        <Stack
          className="bg-white rounded-lg justify-start h-10 border-gray-300 border w-[95%] fixed  left-1/2
        -translate-x-1/2 top-4"
        >
          <Stack className="absolute w-full h-full text-center">
            {percentage}%
          </Stack>
          <div
            className="h-full bg-green-500"
            style={{ width: `${percentage}%` }}
          ></div>
        </Stack>
      )} */}
      <div
        className="w-[90%]  fixed top-1/2 left-1/2 overflow-scroll"
        style={{
          borderRadius: "8px",
          backgroundColor: "white",
          transform: "translate(-50%, -50%)",
          zIndex: 100,
          border: "1px solid #ccc",
          height: "85%",
        }}
      >
        <p className="mt-6 mr-4">
          لطفا فقط متن عربی حدیث خود را در کادر زیر وارد نمایید
        </p>
        <InputWithSuggestionWithDebounceBlur
          className="w-[90%] px-8"
          style={{ height: "150px", margin: "16px" }}
          value={text}
          onChange={(e) => setText(e.target.value)}
          type="text"
          placeholder="متن حدیث"
          textArea={true}
        />
        <Stack className="items-center">
          {!isLoading && !isLabelingLoading && (
            <Button
              variant={"primary"}
              className={"w-50"}
              onClickHandler={onClick}
            >
              {isTranslator ? (
                <span>پیشنهاد ترجمه</span>
              ) : (
                <span>پیشنهاد سطوح</span>
              )}
            </Button>
          )}
        </Stack>

        {isLoading && (
          <div className="h-10 mt-4">
            <CircularProgress
              className="absolute top-1/2 left-1/2 -transform-x-1/2 -transform-y-1/2 z-[100000]"
              color="success"
            />
          </div>
        )}
        <div
          style={{
            flexDirection: "column",
          }}
          className="relative p-6 flex gap-8  items-center "
        >
          {result && (
            <>
              <p>پیشنهاد هوش مصنوعی</p>
              <SingleNarration
                narration={{ content: result, book: "", imam: "", name: "" }}
                className="w-full"
                fold={false}
              />
            </>
          )}

          {resultLabeling && (
            <div className="w-full">
              {onBuffer(resultLabeling)?.map((item, index) => {
                return (
                  <>
                    <h3 className="text-center"> شماره {index + 1}</h3>
                    <SingleNarrationSummariesForRead
                      level1={item.level1}
                      level2={item.level2}
                      level3={item.level3}
                      expression={item.text}
                      isSmallScreen={isSmallScreen}
                      id={index}
                    />
                  </>
                );
              })}
            </div>
          )}
          {isLabelingLoading && (
            <Stack className="items-center">
              <CircularProgress className="w-4 h-4" color="success" />
              <h4>در حال دسته بندی موضوعات...</h4>
            </Stack>
          )}
        </div>
        {(isTranslationDone || isLabelingDone) && (
          <Stack className="justify-center items-center pb-10">
            <Button
              variant="primary"
              className="w-30"
              onClickHandler={() => {
                onConfirm?.(isTranslator ? result : resultLabeling);
                closeAndClearTheModal();
              }}
            >
              جایگذاری
            </Button>
          </Stack>
        )}
        <div ref={endRef}></div>
        <AiOutlineClose
          className="absolute cursor-pointer right-2 top-2"
          onClick={() => {
            closeAndClearTheModal();
          }}
        />
      </div>
    </div>
  );
};

const narrationHasSimilarConfig = (hasSimilar) => {
  if (hasSimilar === true)
    return {
      border: "1px solid var(--error-color)",
      color: "var(--error-color)",
      subText: "حدیث احتمالا تکراری است",
    };
  if (hasSimilar === false)
    return {
      border: "1px solid var(--primary-color)",
      color: "var(--primary-color)",
      subText: "حدیث تکراری نیست",
    };
  return {
    border: undefined,
    color: undefined,
    subText: undefined,
  };
};

export const NarrationEditForm = ({ narration }) => {
  const [trigger, setTrigger] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAIModalOpen, setIsAIModalOpen] = useState(false);
  const [updatedNarration, setUpdatedNarration] = useState(emptyNarration);
  const { narration: storeNarration, isLoading } = useSelector(
    (store) => store.narration
  );
  let { data: imam } = useGetImam();
  imam = imam || [];
  let { data: book } = useGetBooks();
  book = book || [];
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const handleChange = (key, value) => {
    const updated = { ...updatedNarration, [key]: value };
    setUpdatedNarration(updated);
  };
  const { mutate } = useModifyNarrationInfo();
  const navigate = useNavigate();

  const flag = useRef(false);
  const status = useRef();

  const handleBlur = (fieldName, fieldValue, triggerRefetch = false) => {
    status.current = "isLoading";
    if (narration) flag.current = fieldName;
    if (!narration && fieldName === "content" && fieldValue) {
      // setIsModalOpen(true);
      setTrigger(true);
    }
    if (!fieldValue || fieldValue == " ") return;
    if (narration) {
      flag.current = fieldName;
      mutate(
        {
          narrationId: narration?.id,
          data: { [fieldName]: fieldValue },
        },
        {
          onSuccess: () => {
            status.current = "success";
            if (triggerRefetch)
              queryClient.invalidateQueries({
                queryKey: ["narrationIndividual", Number(narration?.id)],
              });
          },
          onError: () => {
            status.current = "error";
          },
        }
      );
    } else {
      flag.current = undefined;
    }
  };

  const handleSubmit = (e) => {
    if (
      !updatedNarration.imam ||
      !updatedNarration.book ||
      !updatedNarration.name ||
      !updatedNarration.narrator ||
      !updatedNarration.content ||
      !updatedNarration.book_vol_no ||
      !updatedNarration.book_page_no ||
      !updatedNarration.book_narration_no ||
      updatedNarration.is_complete === undefined
    ) {
      toast.error("پر کردن همه فیلدهای اطلاعات شناسنامه ای الزامی است");
      return;
    }

    const newNarration = {
      imam: Number(updatedNarration.imam.id),
      book: Number(updatedNarration.book.id),
      name: updatedNarration.name,
      narrator: updatedNarration.narrator,
      content: updatedNarration.content,
      book_vol_no: Number(updatedNarration.book_vol_no),
      book_page_no: Number(updatedNarration.book_page_no),
      book_narration_no: Number(updatedNarration.book_narration_no),
      is_complete: Number(updatedNarration.is_complete),
    };

    dispatch(createNarration(newNarration));
  };
  useEffect(() => {
    if (storeNarration?.id) {
      dispatch(clearNarration());
      navigate(`/my-narrations/${storeNarration?.id}`, {
        preventScrollReset: false,
        replace: true,
      });
    }
  }, [storeNarration]);

  useEffect(() => {
    if (narration) setUpdatedNarration(narration);
  }, [narration]);

  const [hasSimilar, setHasSimilar] = useState(null);
  const { border, color, subText } = narrationHasSimilarConfig(hasSimilar);

  const isCompletedItems = [
    { is_complete: "کامل", id: 0, dataToSend: true },
    { is_complete: "ناقص", id: 1, dataToSend: false },
  ];

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const smallInputsClassName = isSmallScreen ? "col-span-3" : "col-span-1";

  const [similarNarrationsIsLoading, setSimilarNarrationsIsLoading] =
    useState(false);

  return (
    <>
      <SimilarNarrations
        narrationContent={updatedNarration.content}
        setIsOpen={setIsModalOpen}
        isOpen={isModalOpen}
        setHasSimilar={setHasSimilar}
        trigger={trigger}
        setTrigger={setTrigger}
        isLoading={similarNarrationsIsLoading}
        setIsLoading={setSimilarNarrationsIsLoading}
      />
      <ContentContainer className="mb-4" title="اطلاعات شناسنامه‌ای حدیث">
        <div className="grid gap-4 grid-cols-3 grid-rows-3">
          <div
            className={"flex gap-1 " + smallInputsClassName}
            style={{ flexDirection: "column" }}
          >
            <p>نام حدیث</p>
            <InputWithSuggestionWithDebounceBlur
              className="w-full"
              value={updatedNarration?.name}
              onChange={(e) => handleChange("name", e.target.value)}
              onBlur={(e) => handleBlur("name", e.target.value)}
              type="text"
              placeholder="نام حدیث"
              flag={flag?.current === "name"}
              status={status.current}
              key={"i0"}
              debounceDependency={narration?.id}
            />
          </div>
          <div
            className={"flex gap-1 " + smallInputsClassName}
            style={{ flexDirection: "column" }}
          >
            <p>نام معصوم</p>
            <Dropdown
              selected={updatedNarration?.imam}
              setSelected={(newValue) => {
                handleChange("imam", newValue);
                handleBlur("imam", newValue.id, true);
              }}
              // onBlur={(e) => handleBlur("imam", updatedNarration?.imam.id)}
              items={imam}
              dataKey="name"
              placeholder="نام معصوم"
              flag={flag?.current === "imam"}
              key={"i1"}
              debounceDependency={narration?.id}
            />
          </div>

          <div
            className={"flex gap-1 " + smallInputsClassName}
            style={{ flexDirection: "column" }}
          >
            <p>راویان حدیث</p>
            <InputWithSuggestionWithDebounceBlur
              className="w-full"
              value={updatedNarration?.narrator}
              onChange={(e) => handleChange("narrator", e.target.value)}
              onBlur={(e) => handleBlur("narrator", e.target.value)}
              type="text"
              placeholder="راویان حدیث"
              flag={flag?.current === "narrator"}
              status={status.current}
              key={"i2"}
              debounceDependency={narration?.id}
            />
          </div>
          <div
            className={"flex gap-1 row-span-2 col-span-3 mb-1"}
            style={{ flexDirection: "column" }}
          >
            <Stack className="!flex-row gap-2">
              <p>متن حدیث</p>
              <div>
                <Button
                  className="
                        relative overflow-hidden rounded-xl px-7 py-1 font-semibold text-white
                        bg-gradient-to-r from-sky-500 to-blue-600
                        shadow-lg transition duration-300 hover:-translate-y-0.5"
                  variant={"primary"}
                  onClickHandler={() => setIsAIModalOpen(true)}
                >
                  هوش منصوعی
                  <span
                    className="
    absolute inset-0 translate-x-[-120%]
    bg-gradient-to-r from-transparent via-white/40 to-transparent
    animate-[shine_1.5s_ease-in-out_infinite]
  "
                  ></span>
                  <style>
                    {`@keyframes shine {
      0% { transform: translateX(-120%); }
      50% { transform: translateX(120%); }
      100% { transform: translateX(120%); }
    }`}
                  </style>
                </Button>
                <AISuggestion
                  isSmallScreen={isSmallScreen}
                  visible={isAIModalOpen}
                  isOpen={isAIModalOpen}
                  setIsOpen={setIsAIModalOpen}
                  onConfirm={(value) => {
                    handleChange("content", value);
                    handleBlur("content", value);
                  }}
                  isTranslator
                />
              </div>
            </Stack>
            <InputWithSuggestionWithDebounceBlur
              className="w-full mt-2"
              style={{
                height: "100%",
                border,
              }}
              value={updatedNarration?.content}
              onChange={(e) => handleChange("content", e.target.value)}
              onBlur={(e) => handleBlur("content", e.target.value)}
              type="text"
              color={color}
              placeholder="متن حدیث"
              flag={flag?.current === "content"}
              status={status.current}
              textArea={true}
              key={"i3"}
              debounceDependency={narration?.id}
            />
            {hasSimilar !== null && (
              <p className="t-semi-large">
                {similarNarrationsIsLoading && (
                  <div className="flex gap-1 items-center text-2xl text-orange-500">
                    <BiLoader className="w-6 h-6 animate-spin" />
                    <span>در حال بررسی تکراری بودن حدیث. لطفا صبر کنید...</span>
                  </div>
                )}
                {!similarNarrationsIsLoading && hasSimilar && (
                  <>
                    <span className="text-[red]">
                      حدیث ممکن است تکراری باشد. برای دیدن احادیث مشابه احتمالی
                    </span>
                    <span
                      onClick={() => setIsModalOpen(true)}
                      className="underline inline-block mx-1 text-[blue] cursor-pointer"
                    >
                      کلیک کنید
                    </span>
                  </>
                )}
                {!similarNarrationsIsLoading && !hasSimilar && (
                  <>{<p className="text-[green]">این حدیث تکراری نیست</p>}</>
                )}
              </p>
            )}
          </div>
          <div
            className={"flex gap-1 " + smallInputsClassName}
            style={{ flexDirection: "column" }}
          >
            <p>نام کتاب</p>
            <Dropdown
              selected={updatedNarration?.book}
              setSelected={(newValue) => {
                handleChange("book", newValue);
                handleBlur("book", newValue.id, true);
              }}
              items={book}
              dataKey="name"
              placeholder="نام کتاب"
              flag={flag?.current === "book"}
              key={"i4"}
              debounceDependency={narration?.id}
            />
          </div>
          <div
            className={"flex gap-1 " + smallInputsClassName}
            style={{ flexDirection: "column" }}
          >
            <p>شماره جلد کتاب</p>
            <InputWithSuggestionWithDebounceBlur
              className="w-full"
              value={updatedNarration?.book_vol_no}
              onChange={(e) => handleChange("book_vol_no", e.target.value)}
              onBlur={(e) => handleBlur("book_vol_no", e.target.value)}
              type="number"
              placeholder="شماره جلد کتاب"
              flag={flag?.current === "book_vol_no"}
              status={status.current}
              key={"i5"}
              debounceDependency={narration?.id}
            />
          </div>
          <div
            className={"flex gap-1 " + smallInputsClassName}
            style={{ flexDirection: "column" }}
          >
            <p>شماره صفحه</p>
            <InputWithSuggestionWithDebounceBlur
              className="w-full"
              value={updatedNarration?.book_page_no}
              onChange={(e) => handleChange("book_page_no", e.target.value)}
              onBlur={(e) => handleBlur("book_page_no", e.target.value)}
              type="number"
              placeholder="شماره صفحه"
              flag={flag?.current === "book_page_no"}
              status={status.current}
              key={"i6"}
              debounceDependency={narration?.id}
            />
          </div>
          <div
            className={"flex gap-1 " + smallInputsClassName}
            style={{ flexDirection: "column" }}
          >
            <p>شماره حدیث</p>
            <InputWithSuggestionWithDebounceBlur
              className="w-full"
              value={updatedNarration?.book_narration_no}
              onChange={(e) =>
                handleChange("book_narration_no", e.target.value)
              }
              onBlur={(e) => handleBlur("book_narration_no", e.target.value)}
              type="number"
              placeholder="شماره حدیث"
              status={status.current}
              flag={flag?.current === "book_narration_no"}
              key={"i7"}
              debounceDependency={narration?.id}
            />
          </div>
          <div
            className={"flex gap-1 " + smallInputsClassName}
            style={{ flexDirection: "column" }}
          >
            <p>حدیث کامل است؟</p>
            <Dropdown
              selected={
                !updatedNarration?.is_complete
                  ? isCompletedItems[1]
                  : isCompletedItems[0]
              }
              setSelected={(newValue) => {
                handleChange("is_complete", newValue?.dataToSend);
                handleBlur("is_complete", newValue?.dataToSend);
              }}
              items={isCompletedItems}
              dataKey="is_complete"
              placeholder=""
              flag={flag?.current === "is_complete"}
              key={"i8" + narration?.id}
            />
          </div>
        </div>
      </ContentContainer>
      {!narration && (
        <div className="flex justify-end gap-4 my-8">
          <Button
            key={"cancel"}
            variant="secondary"
            type="button"
            className="w-40 h-8"
            style={{ fontSize: "14px" }}
            onClickHandler={() => navigate(-1, { preventScrollReset: false })}
          >
            انصراف
          </Button>
          <Button
            key={"submit"}
            type="button"
            variant="primary"
            className="w-40 h-8"
            style={{ fontSize: "14px" }}
            onClickHandler={handleSubmit}
            disabled={isLoading}
          >
            ذخیره
          </Button>
        </div>
      )}
    </>
  );
};
